import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from 'hooks/useAuth';
// pages
import Login from '../pages/auth/Login/Login';
// components
import LoadingScreen from 'components/LoadingScreen';
import MainHeader from 'layouts/main/MainHeader';
import { Box, Divider, Stack } from '@mui/material';
import MainFooter from 'layouts/main/MainFooter';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return (
      <Stack sx={{ minHeight: 1 }}>
        <MainHeader />
        <Divider />
        <Login />
        <Box sx={{ flexGrow: 1 }} />
        <MainFooter />
      </Stack>)
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
